import Card from "./card";
import Data from "./data";



const Allcards = () =>{

    return(    
    <Card allData = {Data}></Card>   )
    }
    
    export default Allcards;